/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJtr1Z%7Bgrid-area%3Afooter%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._42Yu6Bbhqd%7Bz-index%3A200%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D");



import React from 'react';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { CardFooter as LegacyCardFooter } from './Legacy/CardFooter';
export type CardFooterProps = React.ComponentProps<typeof LegacyCardFooter>;
const styles = {
  footer: "_1xC2CJtr1Z _1mT5xdRAKS _42Yu6Bbhqd _4ouGXIdnbC"
};
export const CardFooter = (props: CardFooterProps): React.JSX.Element => {
  if (!expVal('jira_browse_agent_modal_update', 'isEnabled', false)) {
    return <LegacyCardFooter {...props} />;
  }
  const {
    children,
    testId
  } = props;
  return <Inline xcss={styles.footer} space="space.100" alignInline="start" alignBlock="center" shouldWrap testId={testId}>
			{children}
		</Inline>;
};